export default __webpack_public_path__ + "static/media/mastercard.ad1512ed.png";